/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* mensen.module.ts
* 4-5-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {NgModule} from '@angular/core';
import {Functiescherm} from './functie/functie';
import {Functieedit} from './functie/functieedit';
import {Vastpersoneelscherm} from './vastpersoneel/vastpersoneel';
import {Vastpersoneeledit} from './vastpersoneel/vastpersoneeledit';
import {ModalModule} from 'ngx-bootstrap/modal';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormsModule} from '@angular/forms';
import {SihwDatatableModule} from 'sihw-ng/datatable/datatable.module';
import {CommonModule} from '@angular/common';
import {TabDirective, TabsetComponent} from 'ngx-bootstrap/tabs';
import {Sihwdatepicker} from 'sihw-ngx';
import {SihwDatatable2Module} from 'sihw-ng/datatable2/datatable2.module';
import {XlsDatatable} from 'sihw-ng/xlsx-datatable/xls-datatable';

const schermen = [
  Functiescherm,
  Functieedit,
  Vastpersoneelscherm,
  Vastpersoneeledit
];

@NgModule({
  declarations: schermen,
  imports: [
    CommonModule,
    ColorPickerModule,
    ModalModule.forRoot(),
    FormsModule,
    SihwDatatableModule,
    SihwDatatable2Module,
    XlsDatatable,
    TabsetComponent,
    TabDirective,
    Sihwdatepicker,
  ],
  exports: schermen
})
export class MensenModule {
}
Functiescherm.register('Functiescherm');
Functieedit.register('Functieedit');
Vastpersoneelscherm.register('Vastpersoneelscherm');
Vastpersoneeledit.register('Vastpersoneeledit');
